import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

function Register() {
  const [values, setValues] = useState({
    name: '',
    email: '',
    password: '',
    role: 'docent',
  });

  const [error, setError] = useState('');
  const [emailExists, setEmailExists] = useState(false);
  const navigate = useNavigate();

  const handleEmailBlur = async () => {
    if (values.email.trim() === '') {
      return;
    }

    setError('');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/check-email-existence`,
        {
          params: { email: values.email },
        }
      );

      setEmailExists(response.data.exists);
    } catch (err) {
      console.error('Error checking email existence:', err);
      setError('There was an issue checking the email. Please try again.');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (emailExists) {
      setError('This email is already registered. Please use a different email.');
      return;
    }

    try {
      const registrationResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/register`,
        values
      );

      if (registrationResponse.data.Status === 'Success') {
        navigate('/login');
      } else {
        setError(registrationResponse.data.status);
      }
    } catch (err) {
      console.error('Error during registration:', err);
      setError('An error occurred during registration.');
    }
  };

  return (
    <div className="form-register">
      <div className="form-container">
        <h2>Register</h2>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name</label>
            <input
              className="form-control"
              type="text"
              name="name"
              placeholder="Enter Name"
              onChange={(e) => setValues({ ...values, name: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              className={`form-control ${emailExists ? 'is-invalid' : ''}`}
              type="email"
              name="email"
              placeholder="Enter email"
              onBlur={handleEmailBlur}
              onChange={(e) => {
                setValues({ ...values, email: e.target.value });
                setEmailExists(false);
              }}
            />
            {emailExists && (
              <div className="invalid-feedback">
                This email is already registered.
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Wachtwoord</label>
            <input
              className="form-control"
              type="password"
              name="password"
              placeholder="Enter Password"
              onChange={(e) => setValues({ ...values, password: e.target.value })}
            />
          </div>

          <button type="submit" className="btn-primary">
            Sign up
          </button>

          <p>You agree to our terms and conditions.</p>

          <Link to="/login" className="link-secondary">
            Login
          </Link>
        </form>
      </div>
    </div>
  );
}

export default Register;